// extracted by mini-css-extract-plugin
export default {"animation":"animations__component--lc-ZskLm","component":"Skeleton__component--lc-z8wZM animations__component--lc-ZskLm"};